jQuery( document ).ready(function() {
    if ( jQuery(".rollingText").length ) {
        var rollingTween = new TimelineMax();
        var time = 20;
        var $text = jQuery(".text-rolling")

        function startRolling() {
            $text.css({width:"auto"});
            $text.width(width);
            var width = $text.width();
            
            rollingTween.to(".rollingText", time, {
                x: -width,
                ease: Linear.easeNone,
                repeat: -1
            })

            return rollingTween;
        }

        function rollingText(){
            jQuery('.rollingText').clone().appendTo(".wrapperRollingText");
            startRolling();   
        }
        
        rollingText();
    }
});